module.exports = __webpack_public_path__ + "static/media/emoji-smiling-face-with-open-mouth.40edf893.png";